/* globals google */

import React, { Component } from 'react';
import { get, compact } from 'lodash';
import moment from 'moment-timezone';

import groupMarkers from '../../../marker-layer/group-markers';
import Marker from './marker';

class VehicleHistoryMarkers extends Component {
  get markers() {
    const { vehicleEvents, tz } = this.props;

    const locationMarkers = vehicleEvents.map((vehicleEvent, index) => {
      const markerIndex = vehicleEvent.index ? vehicleEvent.index : index;
      const { latitude, longitude, accuracy } = get(vehicleEvent, 'geo', {});
      if (!latitude || !longitude) {
        return null;
      }

      const dateFormat = 'MMM DD YYYY h:mm a';
      const createdAt = moment.tz(vehicleEvent.createdAt, tz).format(dateFormat);

      const tripIdentifier = get(vehicleEvent, 'tripId', '--').slice(0, 3);

      return {
        position: { lat: latitude, lng: longitude },
        key: vehicleEvent._id,
        labelText: `${markerIndex}`,
        markerStyle: {
          path: google.maps.SymbolPath.CIRCLE,
          fillColor: 'red',
          scale: 10,
          fillOpacity: 1,
          strokeWeight: 0.75,
        },
        zindex: 100,
        createdAt,
        infoItemId: `location-${vehicleEvent._id}`,
        vehicleEvents: [
          {
            text: `${markerIndex} | ${createdAt} | User: ${get(vehicleEvent, 'userId')} | Trip: ${tripIdentifier} | Acc: ${accuracy}`,
            position: `Location: ${latitude.toFixed(4)}, ${longitude.toFixed(4)}`,
          },
        ],
      };
    });

    return groupMarkers(compact(locationMarkers));
  }

  render() {
    const { onClick } = this.props;

    return (
      <div>
        {this.markers.map((marker) => (
          <Marker
            key={marker.key}
            marker={marker}
            onClick={onClick}
          />
        ))}
      </div>
    );
  }
}

export default VehicleHistoryMarkers;
